/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_ActionInputs */

const en_learn_action = /** @type {(inputs: Learn_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Action](/action). What you can do to help (with links to many action-related guides)`)
};

/**
* | output |
* | --- |
* | "[Action](/action). What you can do to help (with links to many action-related guides)" |
*
* @param {Learn_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_action = /** @type {((inputs?: Learn_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_action(inputs)
});